module.exports = __webpack_public_path__ + "static/media/case3.bd2ef6bd.png";